import { updatePaymentMethod } from "@/api/rest/checkoutApi";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import CheckoutPaymentSelectForm from "./CheckoutPaymentSelectForm";
import { CheckoutPaymentAddForm } from "./CheckoutPaymentAddForm";

const Loading = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div>
        <Skeleton
          variant="rectangular"
          height={50}
          sx={{ backgroundColor: "#F6F8FA" }}
        />
      </div>
      <div>
        <Skeleton
          variant="rectangular"
          height={50}
          sx={{ backgroundColor: "#F6F8FA" }}
        />
      </div>
    </div>
  );
};

export const CheckoutPaymentEditForm = ({
  formVisible,
}: {
  formVisible: boolean;
}) => {
  const [showAddPaymentForm, setShowAddPaymentForm] = useState(false);
  const [state, send] = useCheckoutUI();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      !state.context.checkoutIntent?.availablePaymentMethods ||
      state.context.checkoutIntent?.availablePaymentMethods?.length === 0
    ) {
      setShowAddPaymentForm(true);
    } else {
      setShowAddPaymentForm(false);
    }
  }, [state.context.checkoutIntent?.availablePaymentMethods, formVisible]);
  if (!state.context.checkoutIntent?.checkoutIntentId || isLoading) {
    return <Loading />;
  }

  if (showAddPaymentForm) {
    return (
      <CheckoutPaymentAddForm
        onCancel={() => {
          setShowAddPaymentForm(false);
        }}
      />
    );
  }

  return (
    <div>
      <CheckoutPaymentSelectForm
        items={state.context.checkoutIntent?.availablePaymentMethods ?? []}
        selectedItem={state.context.checkoutIntent?.stripePaymentMethod}
        onAddNewPaymentMethod={() => {
          setShowAddPaymentForm(true);
        }}
        value={state.context.checkoutIntent?.stripePaymentMethod?.id ?? ""}
        onChange={async (event, value) => {
          setIsLoading(true);
          const { checkoutIntent, status, errorMessage } =
            await updatePaymentMethod({
              checkoutIntentId: state.context.checkoutIntent?.checkoutIntentId!,
              paymentMethodId: value.id,
            });
          if (status === "success") {
            send({
              type: "SET_CHECKOUT_INTENT",
              data: { checkoutIntent },
            });
          } else {
            send({
              type: "SET_CHECKOUT_ERROR",
              data: { error: errorMessage },
            });
          }
          setIsLoading(false);
        }}
      />
    </div>
  );
};
